import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/Thumbnails' /* webpackChunkName: "Thumbnails" */),
    import(
      './viewer/Thumbnails.controller' /* webpackChunkName: "Thumbnails" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('Thumbnails', UiTypes),
};

export default entry;
